import dynamic from 'next/dynamic'
import { HEADER_SEARCH_FORM_ID } from 'components/search/search-form'
import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import Tracking from 'lib/tracking'
import { getIsBodyFreezed } from 'lib/utils/common/commonUtils'
import Router from 'next/router'
import NoopLoader from '../noop-loader'

const DynamicConfig = { ssr: false, loading: NoopLoader }

const MobileHamburgerMenu = dynamic(
  () => import('components/navigation/mobile-hamburger-menu'),
  DynamicConfig,
)
const DynamicCartNoticeModal = dynamic(
  // eslint-disable-next-line import/no-cycle
  () => import('components/cart/cart-notice'),
  DynamicConfig,
)

const DynamicHeaderUser = dynamic(
  () => import('components/user/header-user'),
  DynamicConfig,
)

const updateHeaderDesktopStyle = (isPhone) => {
  const elem = document.querySelector('header.header')
  const isBodyFreeze = getIsBodyFreezed()

  if (elem && !isBodyFreeze && !isPhone) {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      elem.classList.add('small')
      elem.classList.remove('large')
    } else {
      elem.classList.remove('small')
      elem.classList.add('large')
    }
  }
}

const getProductIds = (cart) => {
  const isCartHasProduct = cart?.items?.length
  const productIDList = isCartHasProduct
    ? cart.items.map((prod) => prod.id_product)
    : []

  return productIDList
}

const trackViewCartEvent = (cart) => {
  const productIds = getProductIds(cart)

  Tracking.trackEvent(Tracking.EVENT_NAME_VIEW_CART, {
    'cart-product-ids': productIds,
  })
}

const injectAppAlert = () => {
  if (typeof document !== 'undefined') {
    const banners = document.querySelectorAll('.banner-header-top')

    if (banners?.length) {
      document.querySelector('header').classList.add('with-app-alert')
    } else {
      document.querySelector('header').classList.remove('with-app-alert')
    }
  }
}

const focusSearchBox = () => {
  const searchForm = document.getElementById(HEADER_SEARCH_FORM_ID)
  const searchInput = searchForm?.querySelector('.pml-input__input')

  if (searchInput) {
    searchInput.focus()
  }
}

const segmentSearchIconClick = (pageName) => {
  if (pageName) {
    segmentTrackAction(EVENT.searchIconClicked, { ref_type: pageName })
  }
}

const handleClickRewards = (ref_type) => {
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()

  const path = ref_type
    ? `/user?page=my-rewards&ref_type=${encodeURIComponent(ref_type)}`
    : `/user?page=my-rewards`

  const pathName = ref_type
    ? `/${shop}/${language}/user/my-rewards?ref_type=${encodeURIComponent(
        ref_type,
      )}`
    : `/${shop}/${language}/user/my-rewards`

  Router.push(path, pathName)
}

export {
  DynamicCartNoticeModal,
  DynamicHeaderUser,
  focusSearchBox,
  injectAppAlert,
  MobileHamburgerMenu,
  segmentSearchIconClick,
  trackViewCartEvent,
  updateHeaderDesktopStyle,
  handleClickRewards,
}
